<template>
    <div class="Cart">
        <h3>購物清單</h3>
        <table>
            <tr class="Carttitle">
                <th>項目</th>
                <th>名稱</th>
                <th>單價</th>
                <th>數量</th>
                <th>小計</th>
                <th>刪除</th>
            </tr>
        <tr class="CartList" v-for= "CartItem in CartItems">
            <td class="CartItem_img">
                <img :src="CartItem.product.img" alt="">
            </td>
            <td class="CartItem_describe">
                {{CartItem.product.title}}
                <br>
                {{CartItem.product.tag}}
            </td>
            <td class="CartItem_price">{{CartItem.product.price}}</td>
            <td class="CartItem_num">
                <button @click="AddNum(CartItem)">+</button>
                {{CartItem.num}}
                <button @click="MinusNum(CartItem)">-</button>
            </td>
            <td class="CartItem_total">{{CartItem.product.price*CartItem.num}}</td>
            <td><button @click="DeleteItem(CartItem)">刪除</button></td>
        </tr>
        </table>
        <div class="Cart_sum">總計  {{PriceSum}}</div>
        <div class="CartButton">
            <button><router-link to="/">繼續購物</router-link></button> 
            <button @click="Checkout();BacktoShop()">確認購買</button>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions} from 'vuex'
export default {
    computed:{
        ...mapState({
            CartItems: state=>state.cart.CartItems
        }),
        ...mapGetters('cart',['PriceSum'])
    },
    methods:{
        ...mapActions('cart',['DeleteItem']),
        ...mapActions('cart',['AddNum']),
        ...mapActions('cart',['MinusNum']),
        ...mapActions('cart',['Checkout']),
        BacktoShop: function(){
            this.$router.push({path:'./CheckoutPage'})
        }

        }
        }

</script>

<style lang="sass">
$MainColor: #FFCBBB
$DarkMainColor: #b25437
@mixin FlexSetting($justify-content:center, $align-items:center)
	display: flex
	justify-content: $justify-content
	align-items: $align-items
.Cart
    margin-top: 80px
    +FlexSetting
    flex-direction: column 
    table
        margin-top: 20px
        border-bottom: 1px solid #000
        tr
            text-align: center
        td
            vertical-align: middle
    .Carttitle
        border-bottom: 1px solid #000
        height: 30px 
        font-weight: 600
        text-align: center
    .CartList
        
        .CartItem_img
            width: 200px
            padding: 10px
            img
                height: 150px
        .CartItem_describe
            width: 150px 
        .CartItem_price
            width: 100px
        .CartItem_num
            width: 100px
        .CartItem_total
            width: 100px
        button 
            border: 0
            background-color: #fff
    .Cart_sum
        font-weight: 600
        Font-size: 24px
    .CartButton
        +FlexSetting
        flex-direction: row
        button
            border: 0
            margin: 5px 10px
            padding: 2px 50px 
            width: 100%
            background-color: $DarkMainColor
            color: #fff
            a
                text-decoration: none
                color: #000
                color: #fff
            &:hover
                background-color: $MainColor
                color: #fff
                cursor: pointer

</style>



// WEBPACK FOOTER //
// src/components/pages/Cart.vue